<template>
<div class="all">
	<iframe :src="url" frameborder="0"></iframe>
</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Image as VanImage,Cascader
	} from 'vant';
	Vue.use(VanImage).use(Cascader);
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		Field
	} from 'vant';
	Vue.use(Field);
	export default {
		data() {
			return {
				url:""
			};
		},
		computed: {
			...mapState(['userInfo','identity','houseId']),
		},
		mounted() {
			var that=this
			this.url=this.$route.query.url;
		},
		methods: {
			
		}
	};
</script>

<style lang="less" scoped>
	.all{
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		iframe{
			width: 100%;
			height: 100%;

		}
	}
</style>
